































































































































































































































































































































































































































import { Component, Prop, Vue } from "vue-property-decorator";
import { storeScEmergency } from "@/store/modules/ScEmergencyStore";
import { storeDokter } from "@/store/modules/dokter";
import ScEmergencySvc from "@/services/ScEmergencyService";
import { appModule } from "@/store/modules/app";
import VCDateTimePicker from "@/components/form_components/VCDateTimePicker.vue";
import { localISODate } from "@/utils/localDate";
import moment from "moment";

const THRESHOLD_MENIT = 30;
const MAX_VALID_MENIT = 300;

@Component({ components: { VCDateTimePicker } })
export default class ScEmergencyForm extends Vue {
  @Prop({ default: null }) eventData!: any;

  storeModule = storeScEmergency;
  event: any = null;
  saving = false;
  signing = false;

  showSignPetugasDialog = false;
  showSignKaIbsDialog = false;
  showSignKomiteDialog = false;
  signPassword = "";

  warningSnackbar = false;
  warningMessage = "";

  t0Time = "";
  t1Time = "";
  t0Date: string | null = null;
  t1Date: string | null = null;

  lookupRegisterId = "";

  kandidatDialog = false;
  kandidatLoading = false;
  kandidatRows: any[] = [];
  kandidatFrom: Date | null = null;
  kandidatTo: Date | null = null;
  kandidatFilter: any = { jenis_tindakan: null, search: "" };
  jadwalTersedia = true;
  kandidatHeaders = [
    { text: "Mulai Tindakan", value: "t1_insisi" },
    { text: "No. RM", value: "pasien_rm" },
    { text: "Nama Pasien", value: "pasien_nama" },
    { text: "Umur", value: "pasien_umur", sortable: false },
    { text: "Operator", value: "operator_nama" },
    { text: "Kategori", value: "category_label" },
    { text: "Jenis", value: "jenis_tindakan" },
    { text: "Check-in (T0)", value: "t0_keputusan" },
    { text: "", value: "aksi", sortable: false },
  ];
  jenisTindakanOptions = [
    { text: "Semua", value: null },
    { text: "Emergensi", value: "emergensi" },
    { text: "Elektif", value: "elektif" },
    { text: "ODC", value: "odc" },
  ];

  shiftOptions = [
    { text: "Pagi", value: "pagi" },
    { text: "Siang", value: "siang" },
    { text: "Malam", value: "malam" },
  ];

  kategoriOptions = [
    { text: "Kategori I (emergensi mengancam jiwa)", value: "i" },
    { text: "Kategori II (komplikasi tidak mengancam jiwa)", value: "ii" },
    { text: "Kategori III (persalinan dini tanpa komplikasi)", value: "iii" },
  ];

  profesiOptions = [
    { text: "Dokter", value: "dokter" },
    { text: "Perawat Anestesi", value: "perawat_anestesi" },
    { text: "Bidan", value: "bidan" },
    { text: "Lainnya", value: "lainnya" },
  ];

  jenisKasusOptions = [
    { text: "Emergensi", value: "emergensi" },
    { text: "Elektif", value: "elektif" },
  ];

  form: any = {
    tanggal_operasi: moment().format("YYYY-MM-DD"),
    shift: this.autoDetectShift(),
    unit_id: "",
    unit_nama: "IBS",
    pasien_rm: "",
    pasien_nama: "",
    register_id: null,
    encounter_id: null,
    operator_nama: "",
    operator_id: null,
    operator_profesi: "dokter",
    jenis_kasus: "emergensi",
    dpjp_id: null,
    diagnosis_pra_op: "",
    diagnosis_icd10: [],
    diagnosis_snomed: [],
    t0_keputusan: null,
    t1_insisi: null,
    kategori_seksio: "i",
    indikasi_klinis: [],
    indikasi_klinis_lainnya_text: "",
    alasan_tindakan_operasi: "",
    alasan_tidak_tercapai: "",
    rencana_tindak_lanjut: "",
    pic_rtl_id: null,
    target_rtl_waktu: "",
    rtl_status: "open",
  };

  // ==================== AUTO-COMPUTE (mirror backend logic) ====================
  get selisihMenit(): number | null {
    if (!this.form.t0_keputusan || !this.form.t1_insisi) return null;
    const t0 = moment(this.form.t0_keputusan);
    const t1 = moment(this.form.t1_insisi);
    if (!t0.isValid() || !t1.isValid()) return null;
    return t1.diff(t0, "minutes");
  }

  get hasilLocal(): string | null {
    if (this.form.kategori_seksio !== "i") return "tidak_dihitung";
    if (this.selisihMenit === null) return null;
    if (this.selisihMenit < 0 || this.selisihMenit > MAX_VALID_MENIT) return "tidak_dihitung";
    if (this.selisihMenit <= THRESHOLD_MENIT) return "tercapai";
    return "tidak_tercapai";
  }

  get hasilLabel(): string {
    const map: any = {
      tercapai: "TERCAPAI",
      tidak_tercapai: "TIDAK TERCAPAI",
      tidak_dihitung: "TIDAK DIHITUNG",
    };
    return map[this.hasilLocal as string] || "—";
  }

  get hasilIcon(): string {
    const map: any = {
      tercapai: "mdi-check-circle",
      tidak_tercapai: "mdi-close-circle",
      tidak_dihitung: "mdi-minus-circle",
    };
    return map[this.hasilLocal as string] || "mdi-help-circle";
  }

  get hasilReason(): string {
    if (this.hasilLocal === "tidak_dihitung" && this.form.kategori_seksio !== "i") {
      return "Kategori " + this.form.kategori_seksio.toUpperCase() + " tidak dihitung";
    }
    if (this.hasilLocal === "tidak_dihitung" && this.selisihMenit !== null &&
        (this.selisihMenit < 0 || this.selisihMenit > MAX_VALID_MENIT)) {
      return "Data waktu tidak valid (T1 < T0 atau selisih > 300 menit)";
    }
    return "";
  }

  get hasilCardColor() {
    const map: any = {
      tercapai: "green lighten-5",
      tidak_tercapai: "red lighten-5",
      tidak_dihitung: "grey lighten-4",
    };
    return map[this.hasilLocal as string] || "";
  }

  get hasilHeaderClass() {
    const map: any = {
      tercapai: "green darken-2 white--text",
      tidak_tercapai: "red darken-2 white--text",
      tidak_dihitung: "grey darken-1 white--text",
    };
    return map[this.hasilLocal as string] || "grey lighten-3";
  }

  get hasilTextClass() {
    const map: any = {
      tercapai: "green--text text--darken-2",
      tidak_tercapai: "red--text text--darken-2",
      tidak_dihitung: "grey--text",
    };
    return map[this.hasilLocal as string] || "";
  }

  get hasilIconColor() {
    const map: any = {
      tercapai: "green darken-2",
      tidak_tercapai: "red darken-2",
      tidak_dihitung: "grey",
    };
    return map[this.hasilLocal as string] || "grey";
  }

  get hasilBoxStyle() {
    if (!this.hasilLocal) return { border: '1px solid #ccc', background: '#fafafa' };
    const map: any = {
      tercapai: { border: '2px solid #1b5e20', background: '#e8f5e9' },
      tidak_tercapai: { border: '2px solid #b71c1c', background: '#ffebee' },
      tidak_dihitung: { border: '1px solid #9e9e9e', background: '#f5f5f5' },
    };
    return map[this.hasilLocal] || { border: '1px solid #ccc', background: '#fafafa' };
  }

  get selisihStyle() {
    if (this.selisihMenit === null) return { background: "#eee", color: "#999" };
    if (this.selisihMenit < 0 || this.selisihMenit > MAX_VALID_MENIT) {
      return { background: "#bdbdbd", color: "#333" };
    }
    if (this.selisihMenit <= THRESHOLD_MENIT) {
      return { background: "#c8e6c9", color: "#1b5e20" };
    }
    return { background: "#ffcdd2", color: "#b71c1c" };
  }

  get isLocked(): boolean {
    return !!(this.event && ["submitted", "ka_ibs_signed", "komite_mutu_signed", "published"].includes(this.event.status));
  }

  get indikasiLainnyaSelected(): boolean {
    return Array.isArray(this.form.indikasi_klinis) && this.form.indikasi_klinis.includes("lainnya");
  }

  get listDokter() {
    return storeDokter.listAll;
  }

  // ==================== LIFECYCLE ====================
  async mounted() {
    await this.storeModule.loadIndikasi();
    // Load master dokter list (for Operator + DPJP autocomplete)
    if (!storeDokter.listAll.length) {
      storeDokter.act_dokter_all();
    }
    if (this.eventData?.id) {
      await this.storeModule.loadDetail(this.eventData.id);
      this.event = this.storeModule.currentEvent;
      this.populateForm();
    }
  }

  autoDetectShift(): string {
    const h = new Date().getHours();
    if (h >= 7 && h < 14) return "pagi";
    if (h >= 14 && h < 21) return "siang";
    return "malam";
  }

  populateForm() {
    if (!this.event) return;
    const e = this.event;

    const copy = [
      "tanggal_operasi", "shift", "unit_id", "unit_nama",
      "pasien_rm", "pasien_nama", "register_id", "encounter_id",
      "operator_nama", "operator_id", "operator_profesi", "jenis_kasus",
      "dpjp_id", "diagnosis_pra_op", "diagnosis_icd10", "diagnosis_snomed",
      "kategori_seksio", "indikasi_klinis", "indikasi_klinis_lainnya_text",
      "alasan_tindakan_operasi",
      "alasan_tidak_tercapai", "rencana_tindak_lanjut",
      "pic_rtl_id", "target_rtl_waktu", "rtl_status",
    ];
    for (const f of copy) {
      if (e[f] !== undefined && e[f] !== null) {
        this.form[f] = e[f];
      }
    }

    if (e.tanggal_operasi) {
      this.form.tanggal_operasi = moment(e.tanggal_operasi).format("YYYY-MM-DD");
    }
    if (e.t0_keputusan) this.setDatetime("t0", e.t0_keputusan);
    if (e.t1_insisi) this.setDatetime("t1", e.t1_insisi);
    if (e.target_rtl_waktu) {
      this.form.target_rtl_waktu = moment(e.target_rtl_waktu).format("YYYY-MM-DD");
    }
    if (!Array.isArray(this.form.indikasi_klinis)) {
      this.form.indikasi_klinis = [];
    }
  }

  onTimeChange(which?: "t0" | "t1") {
    const tgl = this.form.tanggal_operasi || moment().format("YYYY-MM-DD");
    if (which !== "t1" && this.t0Time) {
      this.form.t0_keputusan = `${this.t0Date || tgl} ${this.t0Time}:00`;
    }
    if (which !== "t0" && this.t1Time) {
      this.form.t1_insisi = `${this.t1Date || tgl} ${this.t1Time}:00`;
    }
    this.warnSelisihNegatif();
  }

  setDatetime(which: "t0" | "t1", value: string) {
    const m = moment(value);
    if (!m.isValid()) return;
    const tanggal = m.format("YYYY-MM-DD");
    const beda = tanggal !== this.form.tanggal_operasi ? tanggal : null;
    if (which === "t0") {
      this.form.t0_keputusan = m.format("YYYY-MM-DD HH:mm:ss");
      this.t0Time = m.format("HH:mm");
      this.t0Date = beda;
    } else {
      this.form.t1_insisi = m.format("YYYY-MM-DD HH:mm:ss");
      this.t1Time = m.format("HH:mm");
      this.t1Date = beda;
    }
  }

  warnSelisihNegatif() {
    if (this.selisihMenit !== null && this.selisihMenit < 0) {
      this.showWarning("Jam insisi lebih awal dari jam keputusan — periksa kembali.");
    }
  }

  setNow(which: "t0" | "t1") {
    this.setDatetime(which, moment().format("YYYY-MM-DD HH:mm:ss"));
    this.warnSelisihNegatif();
  }

  openKandidatDialog() {
    if (!this.kandidatFrom) {
      this.kandidatFrom = moment().subtract(7, "days").toDate();
      this.kandidatTo = new Date();
    }
    this.kandidatDialog = true;
    this.loadKandidat();
  }

  async loadKandidat() {
    this.kandidatLoading = true;
    try {
      const res = await ScEmergencySvc.getIbsCandidates({
        tgl_from: this.kandidatFrom ? localISODate(this.kandidatFrom) : undefined,
        tgl_to: this.kandidatTo ? localISODate(this.kandidatTo) : undefined,
        jenis_tindakan: this.kandidatFilter.jenis_tindakan || undefined,
        search: this.kandidatFilter.search || undefined,
      });
      this.kandidatRows = res.data.data || [];
      this.jadwalTersedia = res.data.jadwal_tersedia !== false;
    } catch {
      this.kandidatRows = [];
    } finally {
      this.kandidatLoading = false;
    }
  }

  onKandidatSearchClear() {
    this.kandidatFilter.search = "";
    this.loadKandidat();
  }

  applyKandidat(row: any) {
    const isi: any = {
      register_id: row.register_id,
      pasien_rm: row.pasien_rm,
      pasien_nama: row.pasien_nama,
      unit_id: row.unit_id,
      unit_nama: row.unit_nama,
      tanggal_operasi: row.tanggal_operasi,
      shift: row.shift,
      operator_id: row.operator_id,
      operator_nama: row.operator_nama,
      dpjp_id: row.dpjp_id,
      diagnosis_pra_op: row.diagnosis_pra_op,
      jenis_kasus: row.jenis_kasus,
    };
    Object.keys(isi).forEach(k => {
      if (isi[k] !== null && isi[k] !== undefined && isi[k] !== "") {
        this.$set(this.form, k, isi[k]);
      }
    });
    if (row.register_id) this.lookupRegisterId = String(row.register_id);
    if (row.t1_insisi) this.setDatetime("t1", row.t1_insisi);
    if (row.t0_keputusan) this.setDatetime("t0", row.t0_keputusan);
    this.kandidatDialog = false;
    if (!row.t0_keputusan) {
      this.showWarning("Check-in jadwal operasi tidak ditemukan — isi Jam Keputusan (T0) secara manual");
    } else {
      this.warnSelisihNegatif();
    }
  }

  formatDatetime(v: string) {
    return v ? moment(v).format("DD-MM-YYYY HH:mm") : "-";
  }

  formatTanggal(v: string) {
    return v ? moment(v).format("DD-MM-YYYY") : "-";
  }

  jenisTindakanLabel(v: string) {
    const found = this.jenisTindakanOptions.find(o => o.value === v);
    return found ? found.text : v || "-";
  }

  /** Preview dalam/luar jam kerja dari T0 (mirror config inm.sc_emergency 08:00–14:00). */
  get dalamJamKerjaPreview(): boolean | null {
    if (!this.t0Time) return null;
    return this.t0Time >= "08:00" && this.t0Time < "14:00";
  }

  onOperatorChange() {
    const dokter = this.listDokter.find((d: any) => d.id === this.form.operator_id);
    this.form.operator_nama = dokter ? dokter.nama : "";
  }

  onKategoriChange() {
    // Clear RTL fields jika bukan kategori i
    if (this.form.kategori_seksio !== "i") {
      this.form.alasan_tidak_tercapai = "";
      this.form.rencana_tindak_lanjut = "";
    }
  }

  async doLookup() {
    if (!this.lookupRegisterId) return;
    try {
      const resp = await ScEmergencySvc.lookupPatient(parseInt(this.lookupRegisterId));
      if (resp?.data?.status == "1") {
        const d = resp.data.data;
        this.form.register_id = d.register_id;
        this.form.pasien_rm = d.pasien_rm || "";
        this.form.pasien_nama = d.pasien_nama || "";
        this.form.unit_id = d.unit_id || "";
        if (!this.form.dpjp_id) this.form.dpjp_id = d.dpjp_id || null;
        appModule.NoticeDelay("Data pasien berhasil dimuat");
      }
    } catch {
      // handled
    }
  }

  showWarning(message: string) {
    this.warningMessage = message;
    this.warningSnackbar = true;
  }

  validateBeforeSubmit(forSubmit: boolean): boolean {
    if (!this.form.tanggal_operasi) { this.showWarning("Tanggal Operasi wajib diisi"); return false; }
    if (!this.form.pasien_rm) { this.showWarning("No. RM wajib diisi"); return false; }
    if (!this.form.pasien_nama) { this.showWarning("Nama Pasien wajib diisi"); return false; }
    if (!this.form.operator_nama) { this.showWarning("Nama Operator wajib diisi"); return false; }
    if (!forSubmit) return true;

    if (!this.form.dpjp_id) { this.showWarning("DPJP wajib diisi"); return false; }
    if (!this.form.diagnosis_pra_op || String(this.form.diagnosis_pra_op).length < 5) {
      this.showWarning("Diagnosis Pra-Op wajib diisi (min 5 karakter)"); return false;
    }
    if (!this.form.t0_keputusan || !this.form.t1_insisi) {
      this.showWarning("Jam Keputusan (T0) dan Jam Insisi (T1) wajib diisi"); return false;
    }
    if (!this.form.indikasi_klinis || this.form.indikasi_klinis.length === 0) {
      this.showWarning("Minimal 1 indikasi klinis wajib dipilih"); return false;
    }
    if (this.indikasiLainnyaSelected && !this.form.indikasi_klinis_lainnya_text) {
      this.showWarning("Keterangan indikasi 'Lainnya' wajib diisi"); return false;
    }
    if (!this.form.alasan_tindakan_operasi) {
      this.showWarning("Alasan Tindakan Operasi wajib diisi"); return false;
    }

    if (this.hasilLocal === "tidak_tercapai") {
      if (!this.form.alasan_tidak_tercapai || this.form.alasan_tidak_tercapai.length < 30) {
        this.showWarning("Alasan Tidak Tercapai wajib diisi minimal 30 karakter"); return false;
      }
      if (!this.form.rencana_tindak_lanjut || this.form.rencana_tindak_lanjut.length < 30) {
        this.showWarning("Rencana Tindak Lanjut wajib diisi minimal 30 karakter"); return false;
      }
      if (!this.form.pic_rtl_id) {
        this.showWarning("PIC RTL wajib diisi"); return false;
      }
      if (!this.form.target_rtl_waktu) {
        this.showWarning("Target Waktu RTL wajib diisi"); return false;
      }
    }

    return true;
  }

  buildPayload() {
    const trim = (v: any) => (v === null || v === undefined ? null : String(v).trim() || null);
    return {
      tanggal_operasi: this.form.tanggal_operasi,
      shift: this.form.shift,
      unit_id: trim(this.form.unit_id),
      unit_nama: trim(this.form.unit_nama),
      pasien_rm: trim(this.form.pasien_rm),
      pasien_nama: trim(this.form.pasien_nama),
      register_id: this.form.register_id ? Number(this.form.register_id) : null,
      encounter_id: this.form.encounter_id ? Number(this.form.encounter_id) : null,
      operator_nama: trim(this.form.operator_nama),
      operator_id: this.form.operator_id ? Number(this.form.operator_id) : null,
      operator_profesi: this.form.operator_profesi,
      jenis_kasus: this.form.jenis_kasus,
      dpjp_id: this.form.dpjp_id ? Number(this.form.dpjp_id) : null,
      diagnosis_pra_op: trim(this.form.diagnosis_pra_op),
      diagnosis_icd10: this.form.diagnosis_icd10 || [],
      diagnosis_snomed: this.form.diagnosis_snomed || [],
      t0_keputusan: this.form.t0_keputusan,
      t1_insisi: this.form.t1_insisi,
      kategori_seksio: this.form.kategori_seksio,
      indikasi_klinis: this.form.indikasi_klinis || [],
      indikasi_klinis_lainnya_text: trim(this.form.indikasi_klinis_lainnya_text),
      alasan_tindakan_operasi: trim(this.form.alasan_tindakan_operasi),
      alasan_tidak_tercapai: trim(this.form.alasan_tidak_tercapai),
      rencana_tindak_lanjut: trim(this.form.rencana_tindak_lanjut),
      pic_rtl_id: this.form.pic_rtl_id ? Number(this.form.pic_rtl_id) : null,
      target_rtl_waktu: this.form.target_rtl_waktu || null,
      rtl_status: this.form.rtl_status || "open",
    };
  }

  async simpanDraft() {
    if (!this.validateBeforeSubmit(false)) return;
    this.saving = true;
    try {
      const payload = this.buildPayload();
      let resp;
      if (this.event?.id) {
        resp = await ScEmergencySvc.update(this.event.id, payload);
      } else {
        resp = await ScEmergencySvc.create(payload);
      }
      if (resp?.data?.status == "1") {
        appModule.NoticeDelay("Draft berhasil disimpan");
        this.event = resp.data.data;
        this.$emit("saved");
      }
    } catch { /* handled */ }
    this.saving = false;
  }

  async submitAndSign() {
    if (!this.validateBeforeSubmit(true)) return;
    this.saving = true;
    try {
      const payload = this.buildPayload();
      if (!this.event?.id) {
        const resp = await ScEmergencySvc.create(payload);
        if (resp?.data?.status == "1") {
          this.event = resp.data.data;
        } else {
          this.saving = false;
          return;
        }
      } else {
        // Update draft first
        await ScEmergencySvc.update(this.event.id, payload);
      }
      this.showSignPetugasDialog = true;
    } catch { /* handled */ }
    this.saving = false;
  }

  async doSubmitSign() {
    if (!this.signPassword) { this.showWarning("Password wajib diisi"); return; }
    this.signing = true;
    try {
      const payload = { ...this.buildPayload(), password: this.signPassword };
      const resp = await ScEmergencySvc.submit(this.event.id, payload);
      if (resp?.data?.status == "1") {
        appModule.NoticeDelay("Event berhasil disimpan & ditandatangani Petugas IBS");
        this.showSignPetugasDialog = false;
        this.signPassword = "";
        this.$emit("saved");
        this.$emit("back");
      }
    } catch { /* handled */ }
    this.signing = false;
  }

  async doSignKaIbs() {
    if (!this.signPassword) { this.showWarning("Password wajib diisi"); return; }
    this.signing = true;
    try {
      const resp = await ScEmergencySvc.signKaIbs(this.event.id, { password: this.signPassword });
      if (resp?.data?.status == "1") {
        appModule.NoticeDelay("Berhasil TTD sebagai Ka. IBS");
        this.showSignKaIbsDialog = false;
        this.signPassword = "";
        this.$emit("saved");
        this.$emit("back");
      }
    } catch { /* handled */ }
    this.signing = false;
  }

  async doSignKomite() {
    if (!this.signPassword) { this.showWarning("Password wajib diisi"); return; }
    this.signing = true;
    try {
      const resp = await ScEmergencySvc.signKomiteMutu(this.event.id, { password: this.signPassword });
      if (resp?.data?.status == "1") {
        appModule.NoticeDelay("Berhasil disetujui Komite Mutu");
        this.showSignKomiteDialog = false;
        this.signPassword = "";
        this.$emit("saved");
        this.$emit("back");
      }
    } catch { /* handled */ }
    this.signing = false;
  }

  printPdf() {
    if (this.event?.id) ScEmergencySvc.printPdf(this.event.id);
  }
}
